module.exports = __webpack_public_path__ + "static/media/eventBg.d0b039f2.jfif";